import React from 'react'
import * as R from 'ramda'
import { v4 as uuidv4 } from 'uuid'

import { AlertOctagonIcon, CheckCircleIcon } from 'components/shared/Icon/model'

const INVALID = 'invalid'
const VALID = 'valid'

export const getStatuses = ({ isFinished, isInvalid }) => [
  {
    icon: AlertOctagonIcon,
    id: uuidv4(),
    ref: React.createRef(null),
    type: INVALID,
    isInitialised: R.and(isInvalid, !isFinished),
  },
  {
    icon: CheckCircleIcon,
    id: uuidv4(),
    ref: React.createRef(null),
    type: VALID,
    isInitialised: R.and(isFinished, !isInvalid),
  },
]
